module.exports = __webpack_public_path__ + "img/blankscreen_100.cbc69be2.png";